
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.19 94.19"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"47.1","cy":"47.1","r":"47.1","fill":"#cad3e0"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('circle',{attrs:{"cx":"47.1","cy":"29.98","r":"14.14"}}),_c('path',{attrs:{"d":"M70.77 50.97c-.95-2.2-2.54-5.65-7.54-6.6-1.07-.2-2.11-.26-2.98-.25-.6.01-1.16.13-1.59.34a26.73 26.73 0 01-11.36 2.42h-.42a26.78 26.78 0 01-11.36-2.42 3.84 3.84 0 00-1.59-.34c-.87-.01-1.91.04-2.98.25-5.01.95-6.59 4.4-7.54 6.6 0 0-7.73 17.89-2.3 25.04.33.43 1.2 1.58 3.35 2.1 1.56.37 3.11.24 3.56.21 2.29-.17 8.91-.21 19.07-.16 10.16-.05 16.78-.01 19.07.16.45.03 2 .16 3.56-.21a5.44 5.44 0 003.35-2.1c5.44-7.15-2.3-25.04-2.3-25.04z","stroke":"#cad3e0","stroke-width":"1.37","stroke-miterlimit":"10"}})])])
          )
        }
      }
    